import React from 'react';
import { useHistory } from 'react-router-dom';

export const ErrorGralRec = () => {

    const history = useHistory();


  return (
    <div className="contenedorPromociones">

    <>
            <div className="logoUnefon animate__animated animate__slideInLeft"></div>
            <div className="promo expirada">
                        
            <div className="titulo">Ups!, algo no salió bien.</div>
            <p></p>

            
        
        </div>

            
        </>  
       
</div>
  )
}
